
const SearchRequest = {
  "fromCity": 0,
  "toCity": 0,
  "date": "string",
  "passengerCount": 0
  };
 

  export default SearchRequest;
  